module.exports = __webpack_public_path__ + "img/check.76699ee1.png";